// extracted by mini-css-extract-plugin
export default {"sliderForm":"slider-form_sliderForm__0P05h","button":"slider-form_button__qIIzP"};